module.exports = __webpack_public_path__ + "img/second_2.b2b23469.png";